import classnames from "classnames";
import moment from "moment";
import { Image } from "uikit-react";

import FeatherIcon from "../../common/FeatherIcon";

export const ReservationThreadCard = ({
	reservation,
	selected,
	handleSelect,
	togglePersonalMeta,
	setReservation,
}) => {
	return (
		<div
			className={classnames("chat-guest-contact-wrapper", {
				"active-chat-guest-contact": selected,
				"thread-unread": reservation.thread_meta?.indexOf("unread") >= 0,
			})}
			key={reservation.thread_id}
			onClick={() => {
				handleSelect(reservation.thread_id);
				setReservation(reservation);
			}}
		>
			<div className="message-text-group">
				<Image src="/images/guest-active.svg" />
				<div>
					<div className="chat-guest-contact-name">
						{reservation.first_name} {reservation.last_name}
					</div>
					{/* <div className="chat-guest-contact-address">
              {reservation.pms_id}
            </div> */}
					<div className="chat-guest-contact-date">
						{reservation.last_message_on
							? moment
									.utc(reservation.last_message_on)
									.local()
									.format("MMM DD, YYYY hh:mm a")
							: "No messages yet"}
					</div>
				</div>
			</div>
			<div className="messages-btn-group">
				<span className="hms-simple-icon-btn inbox-read-state-indicator">
					{reservation.thread_meta?.indexOf("unread") >= 0 ? (
						<span className="inbox-unread-dot" />
					) : (
						<FeatherIcon
							name="mail"
							className="inbox-action-icon inbox-read-state-icon"
							color="inherit"
						/>
					)}
				</span>
				<button
					className={classnames("uk-button hms-simple-icon-btn", {
						"icon-active icon-priority":
							reservation.thread_meta?.indexOf("priority") >= 0,
					})}
					type="button"
					uk-tooltip={
						reservation.thread_meta?.indexOf("priority") >= 0
							? "Unprioritize"
							: "Prioritize"
					}
					onClick={() => togglePersonalMeta(reservation.thread_id, "priority")}
				>
					<FeatherIcon
						name="flag"
						className="inbox-action-icon"
						color="inherit"
					/>
				</button>
				<button
					className={classnames("uk-button hms-simple-icon-btn", {
						"icon-active icon-archived":
							reservation.thread_meta?.indexOf("archived") >= 0,
					})}
					type="button"
					uk-tooltip={
						reservation.thread_meta?.indexOf("archived") >= 0
							? "Unarchive"
							: "Archive"
					}
					onClick={() => togglePersonalMeta(reservation.thread_id, "archived")}
				>
					<FeatherIcon
						name="archive"
						className="inbox-action-icon"
						color="inherit"
					/>
				</button>
			</div>
		</div>
	);
};
